import { Button, Container, Grid, Typography } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import ImgContribute from "../../components/ImgContribute";
import notFoundImg from "../../assets/not_found.gif";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import makeStyles from "@mui/styles/makeStyles";
import { setError } from "../../redux/actions";
const useStyles = makeStyles({
  container: {
    alignItems: "center",
    height: window.innerHeight,
    alignContent: "center",
    justifyContent: "center",
    display: "flex",
  },
});
const ExceptionPage = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <>
      <Box className={classes.container}>
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <ImgContribute
                title="illustrations by Storyset"
                src={notFoundImg}
                alt="Contribute"
                link="https://storyset.com"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" align="center">
                Halaman tidak ada!.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                onClick={() => {
                  navigate(-1);
                }}
              >
                Kembali
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    error: state.app.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actSetError: (body) => {
      dispatch(setError(body));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExceptionPage);
